import React from 'react';
import ReactDOM from 'react-dom/client';
import './config/dateConfig'; // side-effect: sets Monday as first day of week (dayjs/antd)
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider} from "react-query";

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </React.StrictMode>
);
// let server = configureServer({});
//
// console.log('All defined routes:');
// server.pretender.handlers.forEach(handler => {
//     console.log(`${handler.path}`);
// });
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
